import axios from 'axios';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

export const getSuggestedDistractors = async (_key: string, question: string, correctAnswers: string[]) => {
  const answers = correctAnswers.map((answer: string) => `texts[]=${answer}&`);
  const response = await axios.get(`/api/v4/suggested_distractors?question=${question}&${answers}`);
  return normalizeJSONAPIResponse(response.data).distractors.map((distractor: any) => distractor.text);
};
